import React from 'react';
import {
  Modal,
  Drawer,
  Form,
  Upload,
  message,
  Radio,
  Icon,
  Typography,
  Table,
  Button,
  Row,
  Col,
  Input,
  notification,
} from 'antd';
import 'antd/dist/antd.css';
// import { ExclamationCircleOutlined } from '@ant-design/icons';

import reqwest from './apiRequest';
import dragula from 'dragula';
import 'dragula/dist/dragula.css';

import './get_sample_banner.css';

// const { Search } = Input;
const imageDataURI = require('image-data-uri');
const { Text, Title } = Typography;

// let searchTimeoutId = false;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }

  return isJpgOrPng && isLt2M;
}

class App extends React.Component {
  state = {
    data: [],
    key: false,
    loading: false,
    visible: false,
    isSendingRequest: false,
    imageDesktopEnUrl: undefined,
    imageDesktopBnUrl: undefined,
    imageMobileEnUrl: undefined,
    imageMobileBnUrl: undefined,
    deleteModalVisible: false,
    searchValue: '',
    detail: {},
  };

  constructor(props) {
    super(props);

    this.columns = [
      {
        title: 'Sort',
        dataIndex: 'sort',
        key: 'display_index',
        width: 60,
        render: () => (
          <Icon
            type="menu"
            style={{
              fontSize: '13pt',
              fontWeight: 'bolder',
              cursor: 'pointer',
            }}
          />
        ),
      },
      {
        title: 'Desktop',
        dataIndex: 'image_desktop',
        key: 'image_desktop',
        // width: 300,
        render: (image_desktop) => (
          <img
            // width="250"
            src={image_desktop}
            style={{ maxHeight: 150 }}
            alt=""
          />
        ),
      },
      {
        title: 'Mobile',
        dataIndex: 'image_mobile',
        key: 'image_mobile',
        render: (image_mobile) => (
          <img
            // width="250"
            src={image_mobile}
            style={{ maxHeight: 150 }}
            alt=""
          />
        ),
      },
      {
        title: 'Active',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        align: 'center',
        render: (status) =>
          status === '1' ? (
            <i className="fa fa-check" style={{ fontSize: 15 }}></i>
          ) : (
            <i className="fa fa-times" style={{ fontSize: 15 }}></i>
          ),
      },
      {
        title: '',
        dataIndex: 'key',
        key: 'key',
        width: 70,
        render: (key) => (
          <Button
            onClick={() => {
              this.showDrawer(key);
            }}
            className="icon-btn"
          >
            <Icon type="edit" />
          </Button>
        ),
      },
    ];
  }

  componentDidMount() {
    document.title = 'Get Sample Banner';

    this.fetch();

    const container = document.querySelector('.ant-table-tbody');
    const drake = dragula([container], {
      moves: (el) => {
        this.start = this.getIndexInParent(el);
        return true;
      },
    });

    drake.on('drop', (el) => {
      this.end = this.getIndexInParent(el);
      this.handleReorder(this.start, this.end);
    });
  }

  fetch = (params = {}) => {
    this.props.pageLoading(true);
    this.setState({ loading: true });

    reqwest({
      url: process.env.REACT_APP_API_URL + '/get_sample_banner',
      method: 'get',
      type: 'json',
      data: {
        search: this.state.searchValue,
        ...params,
      },
    })
      .then((data) => {
        this.setState({
          data: data.results,
        });

        document.body.style.overflow = null;
      })
      .catch((err) => {})
      .always(() => {
        this.props.pageLoading(false);
        this.setState({ loading: false });
      });
  };

  saveRequest = (data = {}) => {
    return reqwest({
      url: process.env.REACT_APP_API_URL + '/get_sample_banner/save',
      method: 'post',
      type: 'json',
      data,
    })
      .then(() => {
        notification.success({
          key: 'notification',
          message: 'Success',
          description: `${data.id ? 'Update' : 'Create'} complete!`,
          duration: 3,
        });

        this.setState({ visible: false });

        this.fetch();
      })
      .catch((err) => {
        notification.error({
          key: 'notification',
          message: 'Fail',
          description: err.message,
          duration: 5,
        });
      })
      .always(() => {
        this.setState({ isSendingRequest: false });
      });
  };

  reorderRequest = (data = {}) => {
    // this.props.pageLoading(true);
    this.setState({ loading: true });

    reqwest({
      url: process.env.REACT_APP_API_URL + '/get_sample_banner/reorder',
      method: 'post',
      type: 'json',
      data,
    })
      .then((data) => {})
      .catch((err) => {})
      .always(() => {
        // this.props.pageLoading(false);
        this.setState({ loading: false });
      });
  };

  deleteRequest = (data = {}) => {
    return reqwest({
      url: process.env.REACT_APP_API_URL + '/get_sample_banner/delete',
      method: 'post',
      type: 'json',
      data,
    })
      .then(() => {
        notification.success({
          key: 'notification',
          message: 'Success',
          description: 'Delete complete!',
          duration: 3,
        });

        this.setState({ visible: false });

        this.fetch();
      })
      .catch((err) => {
        let message = err.message;

        if (err.responseText) {
          let jsonResponse = JSON.parse(err.responseText);
          message = jsonResponse.message;
        }

        notification.error({
          key: 'notification',
          message: 'Fail',
          description: message,
          duration: 5,
        });
      })
      .always(() => {
        this.setState({ isSendingRequest: false });
      });
  };

  getIndexInParent = (el) => {
    return Array.from(el.parentNode.children).indexOf(el);
  };

  showDrawer = async (key) => {
    const data = {
      key: undefined,
      title_en: '',
      title_mm: '',
      image_desktop_en: undefined,
      image_desktop_mm: undefined,
      image_mobile_en: undefined,
      image_mobile_mm: undefined,
      status: '1',
    };

    if ((parseInt(key, 10) || 0) > 0) {
      Object.assign(
        data,
        this.state.data.find((item) => item.key === key) || {},
      );

      // Convert to string
      Object.assign(data, {
        title_en: data.title_en || '',
        title_mm: data.title_mm || '',
        status: `${data.status || 0}`,
      });
    }

    this.props.form.setFieldsValue({
      id: data.key,
      title_en: data.title_en,
      title_mm: data.title_mm,
      image_desktop_en: undefined,
      image_desktop_mm: undefined,
      image_mobile_en: undefined,
      image_mobile_mm: undefined,
      status: data.status,
    });

    this.setState({
      detail: data,
      visible: true,
      isSendingRequest: false,
      imageDesktopEnUrl: undefined,
      imageDesktopMmUrl: undefined,
      imageMobileEnUrl: undefined,
      imageMobileMmUrl: undefined,
    });

    if (data.image_desktop_en) {
      imageDataURI
        .encodeFromURL(data.image_desktop_en)
        .then((base64) => {
          this.props.form.setFieldsValue({
            image_desktop_en: base64,
          });

          this.setState({
            imageDesktopEnUrl: base64,
          });
        })
        .catch((err) => {
          // console.log({ err });
        });
    }

    if (data.image_desktop_mm) {
      imageDataURI
        .encodeFromURL(data.image_desktop_mm)
        .then((base64) => {
          this.props.form.setFieldsValue({
            image_desktop_mm: base64,
          });

          this.setState({
            imageDesktopMmUrl: base64,
          });
        })
        .catch((err) => {
          // console.log({ err });
        });
    }

    if (data.image_mobile_en) {
      imageDataURI
        .encodeFromURL(data.image_mobile_en)
        .then((base64) => {
          this.props.form.setFieldsValue({
            image_mobile_en: base64,
          });

          this.setState({
            imageMobileEnUrl: base64,
          });
        })
        .catch((err) => {
          // console.log({ err });
        });
    }

    if (data.image_mobile_mm) {
      imageDataURI
        .encodeFromURL(data.image_mobile_mm)
        .then((base64) => {
          this.props.form.setFieldsValue({
            image_mobile_mm: base64,
          });

          this.setState({
            imageMobileMmUrl: base64,
          });
        })
        .catch((err) => {
          // console.log({ err });
        });
    }
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onSave = (e) => {
    e.preventDefault();

    this.setState({ isSendingRequest: true });

    this.props.form.validateFields((err, values) => {
      if (err) {
        notification.error({
          key: 'notification',
          message: 'Fail',
          description: 'Please fill complete form!',
          duration: 3,
        });

        this.setState({ isSendingRequest: false });

        return;
      }

      this.saveRequest(values);
    });
  };

  handleImageBeforeUpload = (file, form_property_name, state_property_name) => {
    if (beforeUpload(file)) {
      this.setState({
        loading: true,
      });

      try {
        // Get this url from response in real world.
        getBase64(file, (imageUrl) => {
          const formObject = {};
          formObject[form_property_name] = imageUrl;
          this.props.form.setFieldsValue(formObject);

          const stateObject = {
            loading: false,
          };
          stateObject[state_property_name] = imageUrl;
          this.setState(stateObject);
        });
      } catch (err) {
        const formObject = {};
        formObject[form_property_name] = '';
        this.props.form.setFieldsValue(formObject);

        const stateObject = {
          loading: false,
        };
        stateObject[state_property_name] = '';
        this.setState(stateObject);
      }
    }

    // Alway return false for not allow to upload
    return false;
  };

  showDeleteConfirm = () => {
    Modal.confirm({
      title: 'Confirm',
      // icon: <ExclamationCircleOutlined />,
      content: 'Do you want to delete this item?',
      okText: 'Yes, Delete',
      cancelText: 'No',
      okType: 'danger',
      onOk: () => {
        const detail = this.state.detail;

        return this.deleteRequest({ id: detail.key });
      },
      onCancel: () => {
        Modal.destroyAll();
      },
    });
  };

  handleReorder = (dragIndex, draggedIndex) => {
    const data = [...this.state.data];
    const item = data.splice(dragIndex, 1)[0];
    data.splice(draggedIndex, 0, item);
    this.setState({
      data,
    });

    const postBody = [];
    for (let i = 0; i < data.length; i++) {
      postBody.push({
        key: data[i].key,
        display_order: i + 1,
      });
    }

    this.reorderRequest({ v: postBody });
  };

  render() {
    const {
      isSendingRequest,
      imageDesktopEnUrl,
      imageDesktopMmUrl,
      imageMobileEnUrl,
      imageMobileMmUrl,
      detail,
    } = this.state;

    const { getFieldDecorator } = this.props.form;

    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <div id="get-sample-banner-component">
        <Drawer
          id="get-sample-banner-component-drawer"
          title="GET SAMPLE BANNER DETAIL"
          placement="right"
          closable={false}
          width={730}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form onSubmit={this.onSave} layout={'vertical'}>
            <Form.Item label="" style={{ display: 'none' }}>
              {getFieldDecorator('id', {
                initialValue: '',
              })(<Input />)}
            </Form.Item>
            <Form.Item label="Title (EN)">
              {getFieldDecorator('title_en', {
                initialValue: detail.title_en,
              })(<Input placeholder="" />)}
            </Form.Item>
            <Form.Item label="Title (MM)">
              {getFieldDecorator('title_mm', {
                initialValue: detail.title_mm,
              })(<Input placeholder="" />)}
            </Form.Item>

            <Row gutter={[16, 0]}>
              <Col span={16}>
                <Form.Item label="Image - Desktop (EN)">
                  <Upload
                    accept=".png, .jpg"
                    name="Upload"
                    listType="picture-card"
                    className="photo-uploader"
                    showUploadList={false}
                    beforeUpload={(file) =>
                      this.handleImageBeforeUpload(
                        file,
                        'image_desktop_en',
                        'imageDesktopEnUrl',
                      )
                    }
                  >
                    {imageDesktopEnUrl ? (
                      <img
                        src={imageDesktopEnUrl}
                        alt="Upload"
                        style={{ width: '100%' }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                  {getFieldDecorator('image_desktop_en', {
                    rules: [
                      { required: true, message: 'Please upload image!' },
                    ],
                  })(<Input type="hidden" />)}
                  <div className="text-center">
                    <Text>1400 x 600</Text>
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Image - Mobile (EN)">
                  <Upload
                    accept=".png, .jpg"
                    name="Upload"
                    listType="picture-card"
                    className="photo-uploader"
                    showUploadList={false}
                    beforeUpload={(file) =>
                      this.handleImageBeforeUpload(
                        file,
                        'image_mobile_en',
                        'imageMobileEnUrl',
                      )
                    }
                  >
                    {imageMobileEnUrl ? (
                      <img
                        src={imageMobileEnUrl}
                        alt="Upload"
                        style={{ width: '100%' }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                  {getFieldDecorator('image_mobile_en', {
                    rules: [
                      { required: true, message: 'Please upload image!' },
                    ],
                  })(<Input type="hidden" />)}
                  <div className="text-center">
                    <Text>800 x 600</Text>
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col span={16}>
                <Form.Item label="Image - Desktop (BM)">
                  <Upload
                    accept=".png, .jpg"
                    name="Upload"
                    listType="picture-card"
                    className="photo-uploader"
                    showUploadList={false}
                    beforeUpload={(file) =>
                      this.handleImageBeforeUpload(
                        file,
                        'image_desktop_mm',
                        'imageDesktopMmUrl',
                      )
                    }
                  >
                    {imageDesktopMmUrl ? (
                      <img
                        src={imageDesktopMmUrl}
                        alt="Upload"
                        style={{ width: '100%' }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                  {getFieldDecorator('image_desktop_mm', {
                    rules: [
                      { required: true, message: 'Please upload image!' },
                    ],
                  })(<Input type="hidden" />)}
                  <div className="text-center">
                    <Text>1400 x 600</Text>
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Image - Mobile (BM)">
                  <Upload
                    accept=".png, .jpg"
                    name="Upload"
                    listType="picture-card"
                    className="photo-uploader"
                    showUploadList={false}
                    beforeUpload={(file) =>
                      this.handleImageBeforeUpload(
                        file,
                        'image_mobile_mm',
                        'imageMobileMmUrl',
                      )
                    }
                  >
                    {imageMobileMmUrl ? (
                      <img
                        src={imageMobileMmUrl}
                        alt="Upload"
                        style={{ width: '100%' }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                  {getFieldDecorator('image_mobile_mm', {
                    rules: [
                      { required: true, message: 'Please upload image!' },
                    ],
                  })(<Input type="hidden" />)}
                  <div className="text-center">
                    <Text>800 x 600</Text>
                  </div>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item label="Publish Status">
              {getFieldDecorator('status', {
                validateTrigger: ['onChange', 'onBlur'],
                initialValue: '1',
                rules: [
                  { required: true, message: 'Please input your status!' },
                ],
              })(
                <Radio.Group>
                  <Radio.Button value="1">
                    <i className="fa fa-check" style={{ marginRight: 5 }}></i>
                    Active
                  </Radio.Button>
                  <Radio.Button value="0">
                    <i className="fa fa-close" style={{ marginRight: 5 }}></i>
                    Inactive
                  </Radio.Button>
                </Radio.Group>,
              )}
            </Form.Item>

            <div
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e8e8e8',
                padding: '10px 16px',
                left: 0,
                background: '#fff',
                borderRadius: '0 0 4px 4px',
                zIndex: 2,
              }}
            >
              <Row>
                <Col span={12}>
                  <Button
                    icon="close"
                    onClick={this.onClose}
                    style={{ backgroundColor: '#EDEDED' }}
                  >
                    Close
                  </Button>
                </Col>
                <Col span={12} className="text-right">
                  {detail.key && (
                    <Button
                      style={{
                        marginRight: 8,
                      }}
                      type="danger"
                      ghost
                      icon="delete"
                      onClick={this.showDeleteConfirm}
                      disabled={isSendingRequest}
                    >
                      Delete
                    </Button>
                  )}
                  <Button
                    htmlType="submit"
                    type="primary"
                    icon="save"
                    loading={isSendingRequest}
                    disabled={isSendingRequest}
                  >
                    {!detail.key ? 'Create' : 'Save'}
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Drawer>

        <Row>
          <Col span={24}>
            <Title level={1}>Get Sample Banner</Title>
          </Col>
        </Row>

        <div className="paper-panel">
          <Row>
            <Col className="text-right">
              <Button
                type="primary"
                // style={{ minWidth: 140 }}
                onClick={() => this.showDrawer(-1)}
              >
                <Icon type="plus" />
                Create
              </Button>
            </Col>
          </Row>

          <Table
            columns={this.columns}
            dataSource={this.state.data}
            pagination={this.state.pagination}
            loading={this.state.loading}
            onChange={this.handleTableChange}
            rowKey={'key'}
          />
        </div>
      </div>
    );
  }
}

export default Form.create({ name: 'get_sample_banner_form' })(App);
